import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import BottomNav from '../components/BottomNav';

const BackIcon = () => (<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round"><line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/></svg>);

export default function ExercisesPage() {
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    supabase.from('categories').select('*').order('sort_order').then(({ data }) => {
      if (data) setCategories(data);
      setLoading(false);
    });
  }, []);

  return (
    <div style={{ fontFamily:"'Barlow', sans-serif", background:'#111009', minHeight:'100vh', color:'#F0EBE3', maxWidth:'var(--app-width, 860px)', margin:'0 auto', paddingBottom:80 }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Barlow:wght@300;400;500;600;700&family=Barlow+Condensed:wght@400;600;700;800;900&display=swap');
        * { box-sizing: border-box; margin: 0; padding: 0; }
        button { cursor: pointer; border: none; font-family: inherit; transition: all 0.15s; }
        .bg-grid { position: fixed; inset: 0; pointer-events: none; z-index: 0;
          background-image: linear-gradient(rgba(255,85,0,0.02) 1px, transparent 1px),
            linear-gradient(90deg, rgba(255,85,0,0.02) 1px, transparent 1px);
          background-size: 40px 40px; }
        @keyframes fadeUp { from{opacity:0;transform:translateY(8px)} to{opacity:1;transform:none} }
        .fu { animation: fadeUp 0.25s ease forwards; }
        .cat-card { background:#1C1916; border:1px solid #2A2520; border-radius:12px; cursor:pointer; transition:all 0.18s; overflow:hidden; position:relative; }
        .cat-card:active { transform: scale(0.97); opacity: 0.85; }
      `}</style>
      <div className="bg-grid"/>

      <div style={{ padding:'52px 20px 20px', background:'linear-gradient(180deg, #FF550010 0%, #111009 100%)', position:'relative', zIndex:1 }}>
        <h1 style={{ fontFamily:"'Barlow Condensed'", fontSize:34, fontWeight:900, letterSpacing:1, color:'#F0EBE3', lineHeight:1 }}>EXERCISES</h1>
        <div style={{ fontSize:12, color:'#7A7268', marginTop:4 }}>{categories.length} categories</div>
      </div>

      <div style={{ padding:'16px', position:'relative', zIndex:1 }}>
        {loading ? (
          <div style={{ display:'grid', gridTemplateColumns:'repeat(var(--cat-cols, 3), 1fr)', gap:10 }}>
            {[1,2,3,4,5,6].map(i => <div key={i} style={{ height:110, background:'#1C1916', borderRadius:12, border:'1px solid #2A2520' }}/>)}
          </div>
        ) : (
          <div style={{ display:'grid', gridTemplateColumns:'repeat(var(--cat-cols, 3), 1fr)', gap:10 }}>
            {categories.map((cat, i) => (
              <div key={cat.id} className={`cat-card fu`} style={{ animationDelay:`${i*0.04}s`, opacity:0 }}
                onClick={() => navigate(`/category/${cat.id}`)}>
                <div style={{ height:80, overflow:'hidden', position:'relative', background:(cat.color||'#FF5500')+'18' }}>
                  {cat.image_url
                    ? <img src={cat.image_url} alt="" style={{ width:'100%', height:'100%', objectFit:'cover' }}/>
                    : <div style={{ width:'100%', height:'100%', display:'flex', alignItems:'center', justifyContent:'center', fontSize:32 }}>{cat.emoji||'🥁'}</div>
                  }
                  <div style={{ position:'absolute', bottom:0, left:0, right:0, height:2, background:cat.color||'#FF5500' }}/>
                </div>
                <div style={{ padding:'8px 10px', textAlign:'center' }}>
                  <div style={{ fontSize:12, fontWeight:700, color:'#F0EBE3' }}>{cat.name}</div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      <BottomNav/>
    </div>
  );
}
